import { FC, useContext, useEffect } from "react";

import { SlotMachine } from "../../components/organisms";
import { SocketContext, TeamContext } from "../../context";

const SlotMachinePage: FC<{}> = () => {
    const { socket } = useContext(SocketContext);
    const { teamNumber } = useContext(TeamContext);

    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

    useEffect( () => {
        socket?.emit( "callFacilitator", {gameId: urlTokenExtracted + "/" + teamNumber })
    })

    return (
        <div className="full_screen slot_machine_wrapper">
            <SlotMachine/>
        </div>
    );
};

export default SlotMachinePage;